export default __webpack_public_path__ + "static/media/Candle-1.c55358a9.svg";